
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"39","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M20.5 16c-.276 0-.5-.312-.5-.7v-2.6c0-.389.224-.7.5-.7s.5.311.5.7v2.6c0 .388-.224.7-.5.7M20.5 24c-.276 0-.5-.311-.5-.7v-2.6c0-.388.224-.7.5-.7s.5.312.5.7v2.6c0 .389-.224.7-.5.7M21.5 16c-.276 0-.5-.312-.5-.7v-2.6c0-.389.224-.7.5-.7s.5.311.5.7v2.6c0 .388-.224.7-.5.7M21.5 24c-.276 0-.5-.311-.5-.7v-2.6c0-.388.224-.7.5-.7s.5.312.5.7v2.6c0 .389-.224.7-.5.7M15 32a2 2 0 112-2 2 2 0 01-2 2zm0-2.933a.933.933 0 10.933.933.934.934 0 00-.933-.933zM23 32a2 2 0 112-2 2 2 0 01-2 2zm0-2.933a.933.933 0 10.933.933.934.934 0 00-.933-.933z"}}),_c('path',{attrs:{"d":"M19.169 39.588A19.769 19.769 0 01.092 24.974q-.034-.125-.065-.25A.864.864 0 011.7 24.3l.059.228A18.011 18.011 0 103.743 10.54l5.721 2.311a.864.864 0 01.506.562l3.12 10.828h13.436l2.528-10.1a.864.864 0 011.676.419l-2.692 10.753a.864.864 0 01-.838.654H12.44a.864.864 0 01-.83-.625L8.427 14.294l-6.246-2.523a.863.863 0 01-.438-1.207 19.745 19.745 0 1117.426 29.024","fill":"#fff"}}),_c('path',{staticClass:"a",attrs:{"d":"M24.16 20H13.868a.841.841 0 110-1.68h9.686l.323-.853h-8.614a.878.878 0 01-.7-.349.818.818 0 01-.119-.757l.956-2.787a.866.866 0 01.823-.574h12.909a.854.854 0 01.868.84.854.854 0 01-.868.84H16.848l-.38 1.107h8.652a.877.877 0 01.712.359.818.818 0 01.1.77l-.96 2.533a.867.867 0 01-.812.551"}})])
          )
        }
      }
    